const handleScroll = () => {
  const element = document.getElementById('case-study-from');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export default handleScroll